import { useRef } from 'react'
import classes from './OverflowContainer.module.css'

const OverflowContainer = ({ children, prevent, onScroll, containerRef: externalRef, className }) => {

    const internalRef = useRef(null)
    const containerRef = externalRef || internalRef
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    const mouseMoveHandler = function (e) {
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        // Scroll the element
        containerRef.current.scrollTop = pos.top - dy;
        containerRef.current.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function () {
        containerRef.current.style.cursor = 'grab';
        containerRef.current.style.removeProperty('user-select');

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    };

    function mouseDownHandler(e) {
        // e.preventDefault()
        e.preventDefault && prevent ? e.preventDefault() : e.returnValue = false
        pos = {
            // The current scroll
            left: containerRef.current.scrollLeft,
            top: containerRef.current.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY,
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    }

    const rootClass = className ? `${classes.overflow_container} ${className}` : classes.overflow_container
    return <div className={rootClass} ref={containerRef} onMouseDown={mouseDownHandler} onScroll={onScroll}>
        {children}
    </div>
}

export default OverflowContainer